import { apiHelper } from '@/utils'
import { API } from '@/constants'

/**
 * Game tips — the brand's own tip per game, proxied through Laravel to ai_bot,
 * which owns the rows and the audit trail.
 *
 * What the bot does with them: when a player asks what to play it shares up to
 * three at a time, mixed up, a starred game favoured, a game the player named
 * first. Replaced the JK game list on 2026-11-02.
 *
 * Tenant-scoped in the path for the same reason the FAQ service is: this is a
 * multi-tenant console, and the id is authorised server-side either way.
 */
export const gameTipsService = { list, create, update, remove }

const API_URL = API.BASE_URL + '/v1'

function forTenant(tenantId) {
  return { headers: { 'X-Tenant-Id': String(tenantId) } }
}

export async function list(tenantId) {
  return apiHelper(API_URL).get(`/tenants/${tenantId}/game-tips`, forTenant(tenantId))
}

export async function create(tenantId, payload) {
  return apiHelper(API_URL).post(`/tenants/${tenantId}/game-tips`, payload, forTenant(tenantId))
}

export async function update(tenantId, tipId, payload) {
  return apiHelper(API_URL).put(`/tenants/${tenantId}/game-tips/${tipId}`, payload, forTenant(tenantId))
}

export async function remove(tenantId, tipId) {
  return apiHelper(API_URL).delete(`/tenants/${tenantId}/game-tips/${tipId}`, forTenant(tenantId))
}
